"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ControlMessage_1 = __importDefault(require("../ControlMessage"));
const validations_1 = require("../../../utils/validations");
const utils_1 = require("../../../utils");
class ProxyConnectionResponse extends ControlMessage_1.default {
    constructor({ version = ControlMessage_1.default.LATEST_VERSION, requestId, senderId, streamId, streamPartition, direction, accepted }) {
        super(version, ControlMessage_1.default.TYPES.ProxyConnectionResponse, requestId);
        (0, validations_1.validateIsNotNullOrUndefined)('senderId', senderId);
        this.senderId = senderId;
        (0, validations_1.validateIsString)('streamId', streamId);
        this.streamId = streamId;
        (0, validations_1.validateIsInteger)('streamPartition', streamPartition);
        this.streamPartition = streamPartition;
        (0, validations_1.validateIsNotNullOrUndefined)('accepted', accepted);
        this.accepted = accepted;
        (0, validations_1.validateIsDirection)('direction', direction);
        this.direction = direction;
    }
    getStreamPartID() {
        return (0, utils_1.toStreamPartID)(this.streamId, this.streamPartition);
    }
}
exports.default = ProxyConnectionResponse;
//# sourceMappingURL=ProxyConnectionResponse.js.map